import { render } from "./OlabManufacture.vue?vue&type=template&id=01feefd6&scoped=true"
import script from "./OlabManufacture.vue?vue&type=script&lang=js"
export * from "./OlabManufacture.vue?vue&type=script&lang=js"

import "./OlabManufacture.vue?vue&type=style&index=0&id=01feefd6&scoped=true&lang=css"

import exportComponent from "/Users/ckyang/dev/olabbio/sites/olab-github/gf-olab-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01feefd6"]])

export default __exports__